import React, { FC, memo, useMemo } from 'react';
import { Col, Empty, Row } from 'udesk-ui';
import { Content, Wrapper } from './components';
import Ellipsis from 'src/components/common/Ellipsis';

interface TemplateProps {
    style?: React.CSSProperties;
    height?: number;
    customFields?: any[];
}

const Template: FC<TemplateProps> = memo((props) => {
    const { style, height, customFields } = props;

    const contentHeight = useMemo(() => {
        return height && height >= 38 ? height - 38 : undefined;
    }, [height]);

    return (
        <Wrapper style={{ height, ...style }}>
            {customFields?.length ? (
                <Content height={contentHeight}>
                    {customFields?.map((content, idx) => (
                        <Row key={idx} style={{ marginBottom: 6 }} gutter={4} wrap={false}>
                            <Col flex="120px">
                                <Ellipsis
                                    style={{ width: '100%', textAlign: 'right' }}
                                    text={content.name}
                                    suffix="："
                                />
                            </Col>

                            <Col flex="auto">
                                <Ellipsis text={content.value as string} />
                            </Col>
                        </Row>
                    ))}
                </Content>
            ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}
        </Wrapper>
    );
});

export default Template;
